<template>
  <footer
    ref="target"
  >
    <slot />
  </footer>
</template>

<script>
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  mounted() {
    this.animate();
  },
  methods: {
    animate() {
      let mm = gsap.matchMedia();
      const target = this.$refs.target;
      const inner = target.querySelector('.footer__inner');

      gsap.fromTo(
        inner,
        {
          translateY: '-50%',
        },
        {
          scrollTrigger: {
            trigger: target,
            toggleActions: 'restart none none reverse',
            end: 'bottom bottom',
            scrub: 1
          },
          translateY: '0%',
        }
      )
    }
  }
}
</script>